export const APPLICATION_MODULE = "application";
export const QUESTIONS_MODULE = "questions";
export const STEPS_MODULE = "steps";
export const MAIL_MODULE = "mail";
export const DIALOG_MODULE = "dialog";
export const BELONGINGS_MODULE = "belongings";
